<template>
    <Admin
        :title="__('Coupon create')"
    >
    <div class="grid sm:grid-cols-2 gap-3">
        <InputLabel
            id="name"
            :label="__('Title', null, $page.props.profile_locale)"
            v-model="form.name"
        />

        <InputLabel
            :label="__('Discount', null, $page.props.profile_locale)"
            type="number"
            id="value"
            :min="form.type == 'percent' ? 0 : null"
            :max="form.type == 'percent' ? 100 : null"
            step="0.01"
            v-model.number="form.value"
        />
        <div class="col-span-full" v-if="!coupon || ( coupon && coupon.type != 'first_transaction')">
            <p class="font-bold text-sm text-gray-700">{{__('Type of coupon', null, $page.props.profile_locale)}}</p>
            <Checkbox
                :label="__('One time', null, $page.props.profile_locale)"
                type="radio"
                id="type_one_time"
                value="one-time"
                v-model="form.type"
            />
            <Checkbox
                :label="__('Seasonal', null, $page.props.profile_locale)"
                type="radio"
                id="type_seasonal"
                value="seasonal"
                v-model="form.type"
            />
            <Checkbox
                :label="__('For user', null, $page.props.profile_locale)"
                type="radio"
                id="type_for_user"
                value="for_user"
                v-model="form.type"
            />
            <div class="grid grid-cols-2 gap-3 mt-3" v-if="form.type == 'seasonal'">
                <InputLabel
                    :label="__('From', null, $page.props.profile_locale)"
                    type="date"
                    id="date.from"
                    v-model="form.date.from"
                />
                <InputLabel
                    :label="__('To', null, $page.props.profile_locale)"
                    type="date"
                    id="date.to"
                    v-model="form.date.to"
                />
            </div>
        </div>
        <div class="col-span-2">
            <p class="font-bold text-sm text-gray-700">{{__('Type of discount', null, $page.props.profile_locale)}}</p>
            <Checkbox
                :label="__('Shopping cart', null, $page.props.profile_locale)"
                type="radio"
                id="type_cart"
                value="cart"
                v-model="form.discount_type"
            />
            <Checkbox
                :label="__('Product', null, $page.props.profile_locale)"
                type="radio"
                id="type_product"
                value="product"
                v-model="form.discount_type"
            />
            <div v-if="form.discount_type == 'product'">
                <p class="font-bold text-sm text-gray-700">{{__('Select product', null, $page.props.profile_locale)}}</p>
                <select multiple v-model="form.products" id="products"
                    @change="$page.props.errors.products = null"
                    :class="{
                        ['border-red-500 focus:border-red-600 focus:ring-offset-red-200'] : $page.props.errors.products,
                        ['border-gray-300 focus:border-gray-400 focus:ring-offset-gray-300'] : !$page.props.errors.products,
                    }"
                    size="10"
                >
                    <option class="py-1" :value="item.id" v-for="item in products" :key="item.id">
                        ({{ item.locale.toUpperCase() }}) {{ item.name }}
                    </option>
                </select>
                <div class="text-red-500 text-xs font-bold" v-if="$page.props.errors.products">{{ $page.props.errors.products }}</div>
            </div>
        </div>

        <div class="col-span-2">
            <Button
                @click="updateShipping"
                padding="md"
            >{{__('Update', null, $page.props.profile_locale)}}</Button>
        </div>
    </div>
    </Admin>
</template>

<script>
    import Admin from '@/Layouts/Admin';
    import InputLabel from 'UI/InputLabel';
    import Checkbox from 'UI/Checkbox';

    import { useForm } from '@inertiajs/inertia-vue3';
    import Button from 'UI/Button';

    import {
        getDate,
        getFullTime
    } from 'helper';

    export default {
        components: {
            Admin, InputLabel, Button, Checkbox,
        },
        props: ['products', 'coupon'],
        setup(props) {
            const form = useForm({
                discount_type: props.coupon ? props.coupon.discount_type : 'cart',
                type: props.coupon ? props.coupon.type : 'one-time',
                value: props.coupon ? props.coupon.value : 10,
                name: props.coupon ? props.coupon.name : '',
                date: {
                    from: props.coupon ? getDate(props.coupon.from ? props.coupon.from : new Date(), 'YYYY-MM-DD') : getDate(new Date(), 'YYYY-MM-DD'),
                    to: props.coupon ? props.coupon.to : null,
                },
                products: props.coupon ? getProductId() : [],
            });

            function updateShipping() {
                let url = route().current('dashboard.admin.coupon.edit') ? route('dashboard.admin.coupon.update', props.coupon.id) : route('dashboard.admin.coupon.store')
                form.post(url, {
                    preserveScroll: true,
                    onSuccess: (e) => {},
                })
            }

            function getProductId(){
                let arr = [];
                props.coupon.products.forEach(el => {
                    arr.push(el.id);
                });
                return arr;
            }

            return {
                form,
                updateShipping,

                getDate,
                getFullTime,
            }
        }
    }
</script>
